import { render, staticRenderFns } from "./CustomFooter.vue?vue&type=template&id=a9be2214&scoped=true"
import script from "./CustomFooter.vue?vue&type=script&lang=js"
export * from "./CustomFooter.vue?vue&type=script&lang=js"
import style0 from "./CustomFooter.vue?vue&type=style&index=0&id=a9be2214&prod&scoped=true&lang=less"
import style1 from "./CustomFooter.vue?vue&type=style&index=1&id=a9be2214&prod&lang=css"
import style2 from "./CustomFooter.vue?vue&type=style&index=2&id=a9be2214&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9be2214",
  null
  
)

export default component.exports